module.exports = __webpack_public_path__ + "static/32DCAF_1_0-e3e3f1ae108bc1387672ee1e2953fe68.woff2";